<modal id="{{modalId}}" class="mobileGameModal {{modalId}}">
  <div class="no-padding slot-game_modal">

    <!-- Set Modal Background Image -->
    <!-- <div class="slot-game_modal--set-bg slideInUp" [ngStyle]="{'background-image': getImageUrlPath(gameImg)} " id='gameBgImage'> -->
    <div class="slot-game_modal--set-bg slideInUp" [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + gameUrlPath + '/' + gameImg + '/' + gameImg + '-bg-image.jpg)'} ">
      <div class="middleAlignBlock">
        <div class="middleAlign">

          <!-- Modal main wrapper -->
          <div class="slot-game_modal--content-wrap no-padding">

            <!-- Modal Close Icon -->
            <div class="slot-game_modal--closeicon mobile_modal_closeicon"><span class="game-closeicon"
                (click)="closeModal()">✕</span>
            </div>

            <!-- Modal Body -->
            <div class="slot-game_modal--body no-padding modal-body modal-popup-body">
              <div class="slot-game_modal--innnerbody slotsblks-inner-wrap">

                <!-- <div class="slot-game_modal--header">
                  <h3 class="slot-game_modal--title">{{gameTitle}}</h3>
                  <h5 class="slot-game_modal--sub-title">{{gameVendor}}</h5>
                </div> -->
                
                <!-- Slot Game Modal Img wrapper -->

                <!-- <div class="slot-game_modal--imgwrap"
                  [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + gameUrlPath + '/' + gameImg + '/' + gameImg + '.jpg)'}"> -->

                <div class="slot-game_modal--imgwrap">
                  <div class="img-responsive demo-game--img" [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + gameUrlPath + '/' + gameImg + '/' + gameImg + '.jpg)'} ">
                    <!-- <img src="{{ siteUrlPath + '/' + gameUrlPath + '/' + gameImg + '/' + gameImg + '.jpg' }}"  alt="" class="img-responsive demo-game--img"> -->
                  </div>
                  <!-- <img class="" [src]="getImagePath(gameImg)" (error)="getDefaultUrl($event)"/> -->
                </div>

                <!-- Slot Game Modal Footer wrapper -->
                <div class="slot-game_modal--footer">
                  <div class="slot-game_modal--heading">
                    <h4>{{gameTitle}}</h4>
                    <h6>{{gameVendor}}</h6>
                  </div>
                  <div class="slots-play-btn">
                    <button class="slot-game_modal--loginbtn site-btn site-btn--xs"
                      *ngIf="!userLogin && isCountryAllowed === 2"
                      (click)="movetoLogin(gameImg, gameLaunchUrlPath)">{{'gamingComp.gaming7' | translate}}</button>
                    <button class="slot-game_modal--loginbtn site-btn site-btn--xs"
                      *ngIf="!userLogin && isCountryAllowed === 1"
                      (click)="movetoLogin(gameImg, gameLaunchUrlPath)">{{'gamingComp.gaming21' | translate}}</button>
                    <button class="slot-game_modal--playbtn site-btn site-btn--xs"
                      *ngIf="userLogin"
                      id="slotsplayBtn"
                      (click)="gameLauncher('realgames', gameImg, gameLaunchUrlPath)"><span>{{'gamingComp.gaming8' | translate}}</span></button>
                  </div>
                  <div class="slot-game_modal--funbtn" *ngIf="hasDemo > 0">
                    <button class="transparentBtn site-btn site-btn--xs" *ngIf="!userLogin" id="{{modalId}}-slotsplayBtn"
                    (click)="gameLauncher('freegames', gameImg, gameLaunchUrlPath)">{{'gamingComp.gaming9' | translate}}</button>
                  </div>
                  <!-- <div class="slot-game_modal--funbtn" *ngIf="hasDemo > 0">
                    <button class="transparentBtn" *ngIf="!userLogin" id="{{modalId}}-slotsplayBtn"
                    (click)="gameLauncher('freegames', gameImg, gameLaunchUrlPath)"><span>{{'gamingComp.gaming9' | translate}}</span></button>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>
